import Vue from 'vue';
import Router from 'vue-router';
import paths from './paths';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

Vue.use(Router);
const router = new Router({
    base: '/',
    mode: 'hash',
    linkActiveClass: 'active',
    routes: paths,
    mode: 'history'
});
// router gards
router.beforeEach((to, from, next) => {
    NProgress.start();
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (localStorage.getItem('jwt') == null) {
            next({
                path: '/dang-nhap',
                params: { nextUrl: to.fullPath }
            })
        } else {
            let user = JSON.parse(localStorage.getItem('user'))
            if((user.roleid === 1 && to.meta.roleId >= 0) || (user.roleid === 2 && to.meta.roleId !== 1 && to.meta.roleId >= 0) || (user.roleid === 0 && to.meta.roleId <= 0)){
                next()
            }
            else {
                next({
                    path: '/'
                })
            }
        }
    } else {
        if(from.name == 'Login' && localStorage.getItem('jwt') != null){
            next({
                path: '/'
            })
        }
        else {
            next()
        }
    }
});

router.afterEach((to, from) => {
    NProgress.done();
});

export default router;
